import React from 'react';
import {Typography} from "@material-ui/core";
const QuestionBanner = props => (
  <div className="QuestionBanner">
  <Typography component="div">
    <div style={{ backgroundColor: "#7cc2dba0", color: "black", marginBottom: "4px", textAlign: "left", }}>
      <div style={{ backgroundColor: "white", color: "green", width: "42px", display: "inline-block", }}>
        YES
      </div>
      <div style={{ backgroundColor: "white", color: "orange", width: "42px", display: "inline-block", }}>
        NO
      </div>
      <div className="font-italic" style={{ display: "inline", }}>
        {props.header}
      </div>
    </div>
    </Typography>
  </div>
);

export default QuestionBanner;


// WEBPACK FOOTER //
// ./src/pages/QuestionBanner.js